/**
 * Props de framer-motion para revelar un elemento al entrar en el viewport.
 * Se usa tanto en el componente <Reveal /> como aplicado directamente sobre
 * styled-components: `<MotionCard {...revealProps(0.1)} />`.
 */
export const revealProps = (delay = 0, y = 28) => ({
  initial: { opacity: 0, y },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});
